export const saveColumnWidths = (tableId: string, widths: Record<string, number>) => {
  localStorage.setItem(`table-widths:${tableId}`, JSON.stringify(widths));
};

export const loadColumnWidths = (tableId: string): Record<string, number> | null => {
  const data = localStorage.getItem(`table-widths:${tableId}`);
  return data ? JSON.parse(data) : null;
};
